// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbWrapper":"Breadcrumbs_breadcrumbWrapper__C_CvK","breadcrumbExploreLink":"Breadcrumbs_breadcrumbExploreLink__t7uLY","breadcrumbs":"Breadcrumbs_breadcrumbs__d1A9B"};